import React, { forwardRef } from 'react'
import { NavigateOptions, useNavigate } from 'react-router-dom'
import './button.css'

// UTILITIES
import { flatten } from '@utils/string-helper'


interface ButtonProps extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
    to?: string
    navOptions?: NavigateOptions
    size?: "icon" | "small" | "medium" | "large"
    theme?: "primary" | "secondary" | "dark" | "light"
    companyColor?: string
    blueBorder?: boolean
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
    const { className: classProps, onClick: onClickProps, to, navOptions, type = "button", size = "medium", theme = "primary", blueBorder = false, ...buttonProps } = props
    const className = flatten(size, theme, blueBorder ? "blue-border" : "", "button", classProps)
    const navigate = useNavigate()

    function handleClick(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        if (onClickProps) onClickProps(e);
        if (!!to) navigate(to, navOptions)
    }

    return <button ref={ref} className={className} type={type} onClick={handleClick} {...buttonProps} />
})

export default Button